module.exports = __webpack_public_path__ + "media/images/fao-logo-bbb53f83c6411cb32b40f0f0cc68d765.png";